import React from "react";
import ReportsContainer from "../../containers/reports/index";
import ReportContainer from "../../containers/reports/Report";
import { useParams } from "react-router-dom";

const ReportsPage = () => {
  let { id } = useParams();

  return id ? <ReportContainer id={id} /> : <ReportsContainer />;
};

export default ReportsPage;
